import React from "react";

const Line = (props) => {
  return <div className={`border-t h-[1px] border-t-gray-300  ${props.className}`}></div>;
};

export default Line;
